/* eslint-disable react-hooks/exhaustive-deps */

import { Controller, useFormContext } from 'react-hook-form';
import useProcessRules from 'src/hooks/useProcessRules';
import CustomErrorMessage from './CustomErrorMessage';
import { getRandomValues } from 'src/utils/functiones'
import { Checkbox } from 'primereact/checkbox';
// import { Accordion, AccordionContext, useAccordionToggle } from 'react-bootstrap';




const InputCheck = ({ input }) => {
  const methods = useFormContext();

  const { processValidations } = useProcessRules(input);
  const { control } = methods;
  const rules = processValidations();
  const llave = `${getRandomValues(2)}llave`

  return (
    <>
      <span className="p-float-label">
        <Controller
          control={control}
          name={input.name}
          //defaultValue={watch(input.name) ? watch(input.name) : ''}
          defaultValue=""
          rules={rules}
          render={({ field: { onChange, value } }) => (
            <>
              {!input.descripcion && <div className=" field-checkbox ">
                <Checkbox
                  checked={value}
                  inputId={input.name}
                  name={input.name}
                  className=""
                  onChange={({ checked }) => onChange(checked)}
                />
                {/* card-header bg-white border-0 */}
                {/* check__aceptar__terminos__condiciones */}
                {/* label__aceptar__terminos__condiciones form-check-label ml-2 */}
                <label htmlFor={input.name} className="p-checkbox-label">
                  <span style={{ paddingLeft: 5 }}>{`${input?.titulo || input?.campo}`}</span>
                </label>
              </div>}
              {/* {input?.descripcion && (<>
                <Header eventKey={`${llave}`}>
                  <div className="field-checkbox">
                    <Checkbox
                      checked={value}
                      inputId={input.name}
                      name={input.name}
                      className="check__aceptar__terminos__condiciones"
                      onChange={({ checked }) => onChange(checked)}
                    />
                    <label htmlFor={input.name} className="p-checkbox-label">
                      <span style={{ paddingLeft: 5 }}> {`  q ${input?.titulo || input?.campo}`} </span>
                    </label>
                  </div>
                </Header>
                <Accordion.Collapse eventKey={`${llave}`}>
                  <div
                    className="cobertura__body card-body text-secondary"
                    dangerouslySetInnerHTML={{
                      __html: input.descripcion,
                    }}
                  />
                </Accordion.Collapse>
              </>)} */}
            </>
          )}
        />
        {/* <InputLabel input={input} rules={rules} /> */}
      </span>
      <div className="col-12">
        <CustomErrorMessage name={input.name} />
      </div>
    </>
  );
};

export default InputCheck;


// const Header = ({ children, eventKey }: any = {}) => {
//   const currentEventKey = useContext(AccordionContext);
//   const decoratedOnClick = useAccordionToggle(eventKey, () => { });
//   const isCurrentEventKey = currentEventKey === eventKey;
//   return (
//     <div className="border-bottom pointer row" onClick={decoratedOnClick}>
//       <div className="col-11"  >{children}</div>
//       <div className="col-1 align-self-center">
//         {!isCurrentEventKey && <FiChevronDown />}
//         {isCurrentEventKey && <MdClose />}
//       </div>
//     </div>
//   );
// };